// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1lVLo","obliqueLineWrap":"membershipbadge_obliqueLineWrap__20Q9n","obliqueLine":"membershipbadge_obliqueLine__UjylO"};